import { Client, TokenProvider } from '@pusher/push-notifications-web';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';
import { User } from '../../interfaces/routering/user';
import { LocalStorageService } from './local-storage.service';

@Injectable({providedIn: 'root'})

export class NotificationService {
  constructor(
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
  ) {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((swReg: ServiceWorkerRegistration): void => {
          console.log('Service Worker ready');
          const beamsClient: Client = new Client({
            instanceId: environment.pusher_beams_client_id,
            serviceWorkerRegistration: swReg,
          });

          const beamsTokenProvider: TokenProvider = new TokenProvider({
            url: environment.api_endpoint + 'auth/pusher-beams',
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + this.localStorageService.get('api-token')
            }
          });

          this.authenticationService.user$.subscribe((user: User): void => {
            console.log(user);
            if (user) {
              if (!(window as any).beamsInitialized) {
                (window as any).beamsInitialized = true;

                beamsClient.getUserId()
                  .then((userId: string): void => {
                    console.log(userId);
                    if (!userId || parseInt(userId, 10) !== user.id) {
                      beamsClient.stop().then(() => {
                      });
                    }

                    beamsClient.start()
                      .then(() => beamsClient.clearDeviceInterests()) // avoid duplicate subscriptions
                      .then(() => beamsClient.clearAllState())
                      .then(() => beamsClient.setUserId(user.id.toString(), beamsTokenProvider))
                      .then(() => console.log('Listening for push events for user ' + user.name))
                      .catch(err => console.error('Beams error:', err));
                  });
              }
            } else {
              if ((window as any).beamsInitialized) {
                beamsClient.stop().then((): void => {
                });
                beamsClient.clearAllState().then((): void => {
                });
              }
            }
          });
        })
        .catch(err => console.error('Service Worker registration failed:', err));
    }
  }
}
